import React from 'react'
import { Link } from 'react-router-dom'
import newsletterBanner from "../assets/img/new/VISIT-OUT-SHOP.jpg"
const Newsletter = () => {
  return (
    <section class="newsletter__banner--section section--padding pt-0">
    <div class="container-fluid">
      <div class="newsletter__banner--thumbnail position__relative">
        <img
          class="newsletter__banner--thumbnail__img display-block w-full"
          src={newsletterBanner} 
          alt="newsletter-banner"
        />
        <div class="newsletter__content newsletter__subscribe">
          <h5 class="newsletter__content--subtitle text-white">
            Want to get the best quality deals?
          </h5>
          <Link to='/contact_us'>
          <h2 class="newsletter__content--title text-white h3 mb-25">
            Visit our shop section <br />
            and see our products
          </h2>
          </Link>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Newsletter